import { render, staticRenderFns } from "./NoteDialogForm.vue?vue&type=template&id=35d17464"
import script from "./NoteDialogForm.vue?vue&type=script&lang=js"
export * from "./NoteDialogForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports